import { render, staticRenderFns } from "./VisualEffectSelector.vue?vue&type=template&id=3a1e742e&scoped=true&"
import script from "./VisualEffectSelector.vue?vue&type=script&lang=js&"
export * from "./VisualEffectSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1e742e",
  null
  
)

export default component.exports